export default __webpack_public_path__ + "static/carina-711d54bb1767b1557afdd5e934873bae.jpeg";